import { createContext, useContext, useEffect, useState } from "react";
import axiosConfig from "../config";

export const AuthContext = createContext();


export default function AuthProvider({children}) {
  // states
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = async () => {
    try {
      // get our session
      const currentSession = await axiosConfig.get("/session/current");
      
      // no session, unauthenticated
      if (currentSession.status !== 200) {
        throw new Error("Not authenticated");
      }

      const userId = currentSession.data.session.userId;
  
      // get the user data
      const res = await axiosConfig.get(`/users/${userId}`);

      setUser(res.data.user);
  
    } catch (err) {
      // console.error(err);
      // couldn't load
      setUser(null);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    refresh()
  }, [])

  return (
    <AuthContext.Provider value={{ user, loading, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}


export function useAuth() {
  return useContext(AuthContext);
}